import React, { Component } from "react";
import { withRouter } from '../../common/with-router';
import { Card, Form, Button, Row, Col, InputGroup, Popover, OverlayTrigger} from "react-bootstrap";
import { FaPaperPlane, FaChartBar, FaRegFileAlt, FaCheck } from "react-icons/fa";
import { FiUser, FiClock, FiLayers, FiFlag, FiAlertCircle, FiUploadCloud, FiFileText, FiTag, FiHelpCircle } from 'react-icons/fi';
import { TbCalendarTime, TbCalendarCheck } from 'react-icons/tb';
import AsyncSelect from 'react-select/async';
import api from "../../services/api";
import { getCurrentUser, 
         statusChamados, 
         prioridadeChamados, 
         formataDataHoraExibicao, 
         addBusinessDays, 
         formataDataExibicao, 
         tiposChamados,
         descricoesTipos } from '../../common/utils';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

class ChamadosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);
        this.carregaProgramasDelay = this.delayCamposAsync(this.carregarProgramas.bind(this), 3000);

        this.fileInputRef = React.createRef();

        this.state = {
            erroLoadRegistro: "",
            chamado_id: "",
            titulo_pagina: "Plataforma HNS",
            subtitulo_pagina: "Abertura de Chamados",
            loading: false,
            nome: '',
            status: false,
            dados_usuario: null,

            filtro_programa_id: '',
            filtro_programa_nome: '',   
            numero: "",            
            solicitante: "",  
            solicitante_id: "",
            solicitante_nome: "",      
            data_abertura: new Date(),     
            sla_prazo_dias: 3,            
            tipo: "",
            descricao: "",  
            status: "",             
            prioridade: "",               
            anexos: [],    
            programas: [],  

            mensagensLista: [],
            loadingMensagens: false,
            programasOptions: [],
            loadingProgramas: false,

            mensagensForm: [""],
            enviandoMensagens: false,
            mensagensAnexosSelecionados: [],
            anexosPorMensagem: {},
            isDraggingMsgOver: false,

            dados_programa: [],
            dados_solicitante: [],

            anexosSelecionados: [],   // arquivos novos (File) ainda não enviados
            anexosServidor: [],       // objetos vindos da API
            isDraggingOver: false,

            semPermissao: false,

            processandoValidacao: false,
        };
    }

    async componentDidMount() {
        const id = this.props.router.params.id;

        const dados_user = getCurrentUser();
        const emailUser  = (dados_user && dados_user.email) ? dados_user.email : "";

        this.props.toggleFullScreenMode(true);

        if (id) {
            this.setState({
                chamado_id: id,
                subtitulo_pagina: 'Visualização de Chamado',
                dados_usuario: dados_user,
                solicitante: emailUser,
                loading: true,
                erroLoadRegistro: '',
                programa_id: dados_user.ambiente_programa_id || ''
            });

            Swal.fire({
                title: 'Carregando dados do chamado',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });

            try {
                const response = await api.get(`/chamados/${id}/`);
                const dados = response.data;

                this.setState({
                    erroLoadRegistro: "",
                    numero: dados.numero || "",
                    descricao: dados.descricao || "",
                    filtro_programa_id: dados.programa_id,
                    filtro_programa_nome: dados.dados_programa?.nome || "",

                    solicitante_id: dados.solicitante_id,
                    solicitante_nome: dados.dados_solicitante?.nome || "",

                    data_abertura: dados.criado_em,
                    tipo: dados.tipo || "",
                    status: dados.status ?? "novo",
                    prioridade: String(dados.prioridade ?? "3"),
                    sla_prazo_dias: dados.sla || "3",
                    anexos: dados.anexos,
                });

                await Promise.all([
                    this.carregarMensagensAtendimento(id),
                    this.carregarAnexos(id),
                    this.carregarAnexosMensagens(id)
                ]);

                this.setState({ loading: false });
                
                await new Promise((r) => requestAnimationFrame(r));

                Swal.close();

            } catch (error) {
                let erro_msg = 'Erro ao carregar especialidade médica, tente novamente';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                if (error.response?.data?.detail === "Você não tem permissão para acessar esse registro") {
                    Swal.close();
                    window.location.href = '/sem-permissao';
                    return;
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                    loading: false
                });

                Swal.close();
            }
        } else {
            this.setState({
                chamado_id: '',
                titulo_pagina: "Plataforma HNS",
                dados_usuario: dados_user,
                solicitante: emailUser,
                loading: false,
                erroLoadRegistro: '',
            });
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();
        
        const dados_usuario = getCurrentUser();
        const isSuperUser = dados_usuario.tipo_usuario === "";

        // Validação: Só exige tipo se for Admin editando
        if (isSuperUser && !this.state.tipo) {
            withReactContent(Swal).fire({
                icon: 'warning',
                title: 'Campo Obrigatório',
                text: 'Por favor, selecione o Tipo de Chamado.'
            });
            return;
        }

        //vererifica se é edição ou adição
        const isEdit = !!this.state.chamado_id;

        const user   = getCurrentUser();
        const tipo = String(user?.tipo_usuario || '').toLowerCase();
        const isAdmin = (tipo === 'admin');
        const programaIdFinal = user?.ambiente_programa_id || this.state.filtro_programa_id;
        
        const url = isEdit ? `/chamados/${this.state.chamado_id}/` : `/chamados/`;
        const metodo = isEdit ? 'put' : 'post';

        const payload = isEdit ? {
            //programa_id: programaIdFinal,
            sla: String(this.state.sla_prazo_dias) || 0,
            descricao: this.state.descricao,
            status: this.state.status,
            prioridade: String(this.state.prioridade),
            tipo: this.state.tipo
        } : {
            programa_id: programaIdFinal,
            sla: Number(this.state.sla_prazo_dias) || 0,
            descricao: this.state.descricao,
            numero: this.state.numero,
            status: "novo",
            prioridade: "3",
            tipo: this.state.tipo
        };

        if (isAdmin && this.state.solicitante_id) {
            payload.solicitante_id = this.state.solicitante_id;
        }

        const tituloLoading = isEdit ? 'Atualizando Chamado...' : 'Cadastrando Chamado...';
        Swal.fire({
           title: tituloLoading,
           allowOutsideClick: false,
           didOpen: () => Swal.showLoading(),
        });

        api({
            method: metodo,
            url: url,
            data: payload,
        })
        .then(async (response) => {
            
            const chamadoId = isEdit ? this.state.chamado_id : (response?.data?.id || null);

            // 1) sobe anexos (se houver)
            if (chamadoId) {
                await this.uploadAnexosSelecionados(chamadoId);
            }
            
            this.setState({ loading: false });
            Swal.close();

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{this.state.chamado_id ? 'Chamado atualizado com sucesso' : 'Chamado cadastrado com sucesso'}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                if (result.isConfirmed || result.dismiss) {
                    //redireciona
                    if(!this.state.chamado_id){
                        window.location.href = '/chamados';
                        return;
                    } else {
                        window.location.reload();
                    }
                }
            });
            
        })
        .catch(() => {
            Swal.close();
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>Erro ao cadastrar/atualizar chamado, verifique os campos e tente novamente</p>,
            });
            this.setState({ loading: false });
        });
    };

    carregarUsuariosFuncionarios = (inputValue, callback) => {
        const q = inputValue ? `&nome=${encodeURIComponent(inputValue)}` : "";
        api.get(`/usuarios/?page=1&funcionario=True${q}`)
            .then(res => {
                const results = Array.isArray(res.data?.results)
                    ? res.data.results
                    : (Array.isArray(res.data) ? res.data : []);

                const options = results.map(u => {
                    const first = (u.first_name || "").trim();
                    const last  = (u.last_name  || "").trim();
                    const email = (u.email      || "").trim();
                    const displayName = [first, last].filter(Boolean).join(" ").trim();

                    let label = "";
                        if (displayName && email) label = `${displayName} (${email})`;
                        else if (displayName) label = displayName;
                        else label = email; 
                    return { value: u.id, label };
                });

                callback(options);
            })
            .catch(() => callback([]));
    };

    delayCamposAsync = (fn, delay = 3000) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            return new Promise((resolve) => {
            timeout = setTimeout(async () => {
                try {
                const res = await fn(...args);
                resolve(res);
                } catch (e) {
                resolve([]); 
                }
            }, delay);
            });
        };
    };

    handleChangeSolicitante = (opt) => {
        this.setState({
            solicitante_id: opt?.value || "",
            solicitante_nome: opt?.label || "",
        });
    };

    handleChange = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            const { value, label } = event;
            this.setState({
                [fieldName]: value,
                programa__nome: label,
            });
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    handleStatusChange = () => {
        this.setState(prevState => ({
            status: !prevState.status,
        }));
    };

    handleChangeProgramas(event, fieldName) {
        if (fieldName === 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value,
                filtro_programa_nome: event.label,
            }));
        }
    }

    carregarProgramas = async (inputValue = "") => {
        try {
            if (!inputValue) {
                this.setState({ loadingProgramas: true });
            }

            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));

            if (!inputValue) {
                this.setState({
                    programasOptions: opcoes,
                    loadingProgramas: false
                });
            }
            return opcoes;

        } catch (error) {
            console.error("Erro ao carregar programas:", error);
            if (!inputValue) {
                this.setState({ loadingProgramas: false });
            }
            return [];
        }
    };

    carregarMensagensAtendimento = (chamado_id) => {
        if (!chamado_id) return Promise.resolve([]);

        this.setState({ loadingMensagens: true });

        api.get(`/chamados/mensagens/?chamado_id=${chamado_id}`)
            .then((response) => {
            const mensagens = Array.isArray(response.data.results) ? response.data.results : [];
            this.setState({ mensagensLista: mensagens, loadingMensagens: false });
            })
            .catch((error) => {
            console.error('Erro ao carregar mensagens:', error);
            this.setState({ loadingMensagens: false, mensagensLista: [] });
            });
    };

    handleChangeMensagem = (idx, e) => {
        const value = e.target.value;
        this.setState((s) => {
            const msgs = [...s.mensagensForm];
            msgs[idx] = value;
            return { mensagensForm: msgs };
        });
    };

    handleEnviaMensagens = async (e) => {
        e?.preventDefault?.();

        const MySwal = withReactContent(Swal);
        const { mensagensForm, chamado_id, statusChamados } = this.state;
        if (statusChamados === "Concluido") return;

        const mensagem = (mensagensForm?.[0] || "").trim();
        if (!mensagem) {
            MySwal.fire({
                icon: 'warning',
                title: <p>Aviso</p>,
                html: 'Escreva a mensagem antes de salvar.',
                showCloseButton: true,
            });
            return;
        }

        this.setState({ enviandoMensagens: true });

        Swal.fire({
           title: "Salvando comentário",
           allowOutsideClick: false,
           didOpen: () => Swal.showLoading(),
        });

        api({
            method: 'post',
            url: '/chamados/mensagens/',
            data: { chamado_id, mensagem },
        })
        .then(async (res) => {
            const mensagemId = res?.data?.id;
            await this.uploadMensagemAnexosSelecionados(mensagemId, chamado_id);

            Swal.close();

            MySwal.fire({
                icon: 'success',
                title: <p>Comentário enviado</p>,
                showCloseButton: true,
            });

            this.setState({ mensagensForm: [''] });
            this.carregarMensagensAtendimento(chamado_id);
            this.carregarAnexosMensagens(chamado_id);
        })
        .catch((error) => {
            let erro_msg = 'Falha ao enviar o comentário.';
            let content = '';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
            const campos = error.response.data || {};
            if (campos.chamado_id) 
                content += `<br>&bull; Chamado: ${campos.chamado_id}`;
            if (campos.mensagem)  
                content += `<br>&bull; Mensagem: ${campos.mensagem}`;
            }

            MySwal.fire({
                icon: 'error',
                title: <p>{erro_msg}</p>,
                html: content,
                showCloseButton: true,
            });
        })
        .finally(() => {
            this.setState({ enviandoMensagens: false });
        });
    };

    handleNumeroChamadoChange = (e) => {
        const onlyDigits = (e.target.value || "").replace(/\D/g, "").slice(0, 7); 
        const year = onlyDigits.slice(0, 4);
        const seq  = onlyDigits.slice(4, 7);

        const masked = `HNS-${year.padEnd(4, "A")}-${seq.padEnd(3, "#")}`;
        this.setState({ numero: masked });
    };

    addFiles = (files) => {
        const max = 10 * 1024 * 1024; // 10MB
        const validos = Array.from(files || []).filter(f => f.size <= max);
        const novos = validos.map(file => ({
            previewUrl: URL.createObjectURL(file),
            name: file.name,
            type: file.type || '',
            file,
        }));
        this.setState(s => ({ anexosSelecionados: [...(s.anexosSelecionados || []), ...novos] }));
    };

    handleFileChange = (e) => {
        const files = Array.from(e.target.files || []);
        e.target.value = '';

        const totalServidor = this.state.anexosServidor?.length || 0;
        const totalStaging  = this.state.anexosSelecionados?.length || 0;
        const restante = 5 - (totalServidor + totalStaging);

        if (restante <= 0) {
            withReactContent(Swal).fire({
                icon: 'warning',
                title: 'Limite de anexos',
                text: 'Cada chamado permite no máximo 5 arquivos.',
                timer: 2500
            });
            return;
        }

        // se veio mais do que cabe, corta e avisa
        const aceitos = files.slice(0, restante);
        if (aceitos.length < files.length) {
            withReactContent(Swal).fire({
                icon: 'info',
                title: 'Alguns arquivos foram ignorados',
                text: `Cada chamado permite no máximo 5 arquivos.`,
                timer: 2500
            });
        }

        // reaproveita sua função existente
        this.addFiles(aceitos); 
    };

    handleDragOver = (e) => { e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; };
    handleDragEnter = (e) => { e.preventDefault(); this.setState({ isDraggingOver: true }); };
    handleDragLeave = (e) => { e.preventDefault(); this.setState({ isDraggingOver: false }); };
    handleDrop = (e) => {
        e.preventDefault();
        this.setState({ isDraggingOver: false });
        if (e.dataTransfer?.files?.length) {
            this.addFiles(e.dataTransfer.files);
        }
    };

    handleRemoveAnexoLocal = (idx) => {
        this.setState((s) => {
            const arr = [...(s.anexosSelecionados || [])];
            const item = arr[idx];
            try { if (item?.previewUrl) URL.revokeObjectURL(item.previewUrl); } catch {}
            arr.splice(idx, 1);
            return { anexosSelecionados: arr };
        });
    };

    handleRemoveAnexo = (idx) => {
        this.setState((s) => {
            const arr = [...(s.anexos || [])];
            const item = arr[idx];
            // se for preview local, revoga o URL
            try { if (item?.url && item?.file instanceof File) URL.revokeObjectURL(item.url); } catch {}
            arr.splice(idx, 1);
            return { anexos: arr };
        });
    };


    isImage = (item) => {
        const t = (item.type || "").toLowerCase();
        const n = (item.name || "").toLowerCase();
        return t.startsWith("image/") || /\.(png|jpe?g|gif|webp)$/i.test(n);
    };

    iconForFile = (name = '', type = '') => {
        const n = name.toLowerCase();
        const t = (type || '').toLowerCase();
        if (this.isImage({ name, type })) return 'img';
        if (n.endsWith('.pdf') || t.includes('pdf')) return 'pdf';
        if (/\.(docx?|odt)$/i.test(n)) return 'doc';
        if (/\.(xlsx?|ods|csv)$/i.test(n)) return 'xls';
        return 'file';
    };

    carregarAnexos = async (chamado_id) => {
        if (!chamado_id) return;
        try {
            const res = await api.get(`/chamados/anexos/?chamado_id=${chamado_id}`);
            const rows = Array.isArray(res.data?.results) ? res.data.results : (res.data || []);
            this.setState({ anexosServidor: rows });
        } catch (e) {
            this.setState({ anexosServidor: [] });
        }
    };

    uploadAnexosSelecionados = async (chamadoId) => {
        const { anexosSelecionados } = this.state;
        if (!chamadoId || !anexosSelecionados?.length) return;

        for (const it of anexosSelecionados) {
            const fd = new FormData();
            fd.append('chamado_id', String(chamadoId));
            fd.append('arquivo', it.file, it.name);

            try {
            await api.post('/chamados/anexos/', fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            } catch (err) {
            console.warn('Falha ao enviar anexo:', it?.name, err);
            }
        }

        // limpa staging e recarrega do servidor
        this.setState({ anexosSelecionados: [] });
        await this.carregarAnexos(chamadoId);
    };

    handleExcluirAnexoServidor = async (anexo) => {
        const MySwal = withReactContent(Swal);
        try {
            const { isConfirmed } = await MySwal.fire({
                title: 'Excluir anexo?',
                text: this.filenameFromUrl(anexo.url || anexo.link || anexo.arquivo_url || '') || 'Este arquivo será removido.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Excluir',
                cancelButtonText: 'Cancelar'
            });
            if (!isConfirmed) return;

            await api.delete(`/chamados/anexos/${anexo.id}/`);
            this.setState(s => ({ anexosServidor: s.anexosServidor.filter(a => a.id !== anexo.id) }));

            MySwal.fire({ icon: 'success', title: 'Anexo excluído', timer: 1200, showConfirmButton: false });
        } catch (e) {
            MySwal.fire({ icon: 'error', title: 'Erro ao excluir anexo' });
        }
    };

    filenameFromUrl = (url) => {
        try {
            if (!url) return '';
            const u = new URL(url);
            // pega o último segmento do path e decodifica (ex.: "resized_logo.png")
            const last = u.pathname.split('/').filter(Boolean).pop() || '';
            return decodeURIComponent(last);
        } catch {
            // fallback burro se não for URL válida
            const semQuery = String(url).split('?')[0];
            return decodeURIComponent(semQuery.split('/').pop() || '');
        }
    };

    //ANEXOS MENSAGENS
    uploadMensagemAnexosSelecionados = async (mensagemId, chamadoId = this.state.chamado_id) => {
        const files = this.state.mensagensAnexosSelecionados || [];
        if (!mensagemId || !chamadoId || !files.length) return;

        for (const it of files) {
            const anexoMng = new FormData();
            anexoMng.append('mensagem_id', String(mensagemId));  
            anexoMng.append('chamado_id', String(chamadoId));   
            anexoMng.append('arquivo', it.file, it.name);

            try {
            await api.post('/chamados/anexos/', anexoMng, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            } catch (err) {
            console.warn('Falha ao enviar anexo da mensagem:', it?.name, err);
            }
        }

        this.setState({ mensagensAnexosSelecionados: [] });
    };

    addMensagemFiles = (fileList) => {
        const maxMB = 10 * 1024 * 1024;
        const atuais = this.state.mensagensAnexosSelecionados || [];
        const restante = 5 - atuais.length;           

        if (restante <= 0) {
            withReactContent(Swal).fire({ icon: 'warning', title: 'Limite de anexos', text: 'Máx. 5 anexos por comentário.' });
            return;
        }

        const files = Array.from(fileList || []);
        const aceitos = files.slice(0, restante).filter(f => {
            const ok = f.size <= maxMB;
            if (!ok) console.warn('Arquivo >10MB ignorado:', f.name);
            return ok;
        }).map(f => ({
            file: f,
            name: f.name,
            type: f.type || '',
            previewUrl: f.type?.startsWith('image/') ? URL.createObjectURL(f) : null,
        }));

        if (files.length > restante) {
            withReactContent(Swal).fire({ icon: 'info', title: 'Alguns arquivos ignorados', text: `Só cabiam ${restante}.` });
        }

        this.setState({ mensagensAnexosSelecionados: [...atuais, ...aceitos] });
    };

    handleMensagemFileChange = (e) => {
        this.addMensagemFiles(e.target.files);
        e.target.value = '';
    };

    handleMensagemDragOver  = (e) => { e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; };

    handleMensagemDragEnter = () => this.setState({ isDraggingMsgOver: true });

    handleMensagemDragLeave = () => this.setState({ isDraggingMsgOver: false });

    handleMensagemDrop = (e) => {
        e.preventDefault();
            this.setState({ isDraggingMsgOver: false });
            if (e.dataTransfer?.files?.length) this.addMensagemFiles(e.dataTransfer.files);
    };

    handleRemoveMensagemAnexoLocal = (idx) => {
        this.setState(s => {
            const arr = [...(s.mensagensAnexosSelecionados || [])];
            const rem = arr.splice(idx, 1)[0];
            try { if (rem?.previewUrl) URL.revokeObjectURL(rem.previewUrl); } catch {}
            return { mensagensAnexosSelecionados: arr };
        });
    };

    carregarAnexosMensagens = async (chamado_id) => {
        if (!chamado_id) return;
        try {
            const res = await api.get(`/chamados/anexos/?chamado_id=${chamado_id}`);
            const rows = Array.isArray(res.data?.results) ? res.data.results : (res.data || []);
            const porMsg = rows.reduce((acc, a) => {
            const mid = a.mensagem_id;
            if (mid) (acc[mid] = acc[mid] || []).push(a);
            return acc;
            }, {});
            this.setState({ anexosPorMensagem: porMsg });
        } catch {
            this.setState({ anexosPorMensagem: {} });
        }
    };

    handleAprovarConclusao = async () => {
        const { chamado_id } = this.state;
        if (!chamado_id) return;

        const MySwal = withReactContent(Swal);

        const { isConfirmed } = await MySwal.fire({
            title: 'Aprovar conclusão do chamado?',
            text: 'Tem certeza que deseja aprovar e encerrar este chamado?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, aprovar',
            cancelButtonText: 'Cancelar'
        });

        if (!isConfirmed) return;

        try {
            Swal.fire({
                title: "Aprovando chamado",
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });

            this.setState({ processandoValidacao: true });
            await api.put(`/chamados/${chamado_id}/`, { status: 'concluido' });

            Swal.close();

            await MySwal.fire({
                icon: 'success',
                title: 'Chamado concluído',
                timer: 1400,
                showConfirmButton: false
            });

            this.setState({ status: 'concluido', processandoValidacao: false });
        } catch (e) {
            this.setState({ processandoValidacao: false });
            MySwal.fire({ icon: 'error', title: 'Falha ao concluir chamado' });
        }
    };

    handleReprovarConclusao = async () => {
        const { chamado_id } = this.state;
        if (!chamado_id) return;

        const MySwal = withReactContent(Swal);

        const { value: motivo, isConfirmed } = await MySwal.fire({
            title: 'Motivo da reprovação',
            input: 'textarea',
            inputPlaceholder: 'Descreva o motivo…',
            inputAttributes: { 'aria-label': 'Motivo da reprovação' },
            inputValidator: (v) => (!v || !v.trim() ? 'Informe o motivo.' : undefined),
            showCancelButton: true,
            confirmButtonText: 'Reprovar',
            cancelButtonText: 'Cancelar'
        });
        if (!isConfirmed) return;

        try {
            this.setState({ processandoValidacao: true });
            Swal.fire({
                title: "Reprovando chamado",
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            
            // 1) muda status para em_andamento
            await api.put(`/chamados/${chamado_id}/`, { status: 'andamento' });

            // 2) registra comentário com o motivo
            const mensagem = `Reprovação da conclusão:\n${motivo.trim()}`;
            await api.post('/chamados/mensagens/', { chamado_id, mensagem });

            Swal.close();

            await MySwal.fire({ icon: 'success', title: 'Chamado reaberto para ajustes', timer: 1500, showConfirmButton: false });

            //window.location.reload();

            this.setState({ status: 'andamento', processandoValidacao: false, mensagensForm: [''] });
            this.carregarMensagensAtendimento(chamado_id);
        } catch (e) {
            this.setState({ processandoValidacao: false });
            MySwal.fire({ icon: 'error', title: 'Falha ao reprovar conclusão' });
        }
    };

    renderAjudaTipos = (props) => (
        <Popover 
            id="popover-tipos-chamado" 
            {...props} 
            style={{ ...props.style, maxWidth: '400px' }} 
        >
            <Popover.Header as="h3" className="bg-light fw-bold">Guia de Tipos de Chamado</Popover.Header>
            <Popover.Body>
                <ul className="list-unstyled mb-0 small">
                    <li className="mb-2"><strong>Suporte Técnico:</strong> {descricoesTipos.suporte_tecnico}</li>
                    <li className="mb-2"><strong>Solicitação de Acesso:</strong> {descricoesTipos.solicitacao_acesso}</li>
                    <li className="mb-2"><strong>Erro de Integração:</strong> {descricoesTipos.erro_integracao}</li>
                    <li className="mb-2"><strong>Ajuste de Cadastro:</strong> {descricoesTipos.ajuste_cadastro}</li>
                    <li className="mb-2"><strong>Dúvida Operacional:</strong> {descricoesTipos.duvida_operacional}</li>
                    <li className="mb-2"><strong>Melhoria / Evolutiva:</strong> {descricoesTipos.melhoria_evolutiva}</li>
                    <li className="mb-0"><strong>Incidente Crítico:</strong> {descricoesTipos.incidente_critico}</li>
                </ul>
            </Popover.Body>
        </Popover>
    );

    render(){
        const customStyles = {
            option: (provided) => ({
                ...provided,
                fontSize: '13px',
            }),
            singleValue: (provided) => ({
                ...provided,
                fontSize: '13px',
            }),
        };
        
        const isEdit = !!this.state.chamado_id;

        const dados_usuario = getCurrentUser();
        const isSuperUser = dados_usuario.tipo_usuario === "";
        const isViewer = (dados_usuario['tipo_usuario'] === 'operador' || dados_usuario['tipo_usuario'] === 'gestor' || (dados_usuario['is_staff'] === true && dados_usuario['tipo_usuario'] === 'administrador'));


        const abertura = this.state.data_abertura ? new Date(this.state.data_abertura) : null;
        const slaDias = Number(this.state.sla_prazo_dias) || 0;
        // Se quiser feriados, definir aqui: const feriados = ['2025-12-25', '2025-01-01'];
        const previsao = abertura ? addBusinessDays(abertura, slaDias /*, feriados */) : null;


        return (
           <div className="page-atendimentos pb-5">
                <div className="hns-topbar">
                    <Row className="justify-content-center">
                        <Col md={10} lg={9} xl={8} xxl={7} className="p-0">
                            <Row className="justify-content-center">
                                <Col sm={8} lg={8} className="d-flex align-items-center gap-3">
                                    <span className="hns-topbar-icon"><FaRegFileAlt /></span>
                                    <div>
                                        <div className="hns-topbar-title">{this.state.titulo_pagina}</div>
                                        <div className="hns-topbar-subtitle">{this.state.subtitulo_pagina}</div>
                                    </div>
                                </Col>
                                <Col sm={4} lg={4} className="hns-topbar-dashboard">
                                    <Button href="/chamados" variant="light" size="sm">
                                        <FaChartBar className="me-2" /> Dashboard
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <Row className="justify-content-center  mb-5">
                    <Col md={10} lg={9} xl={8} xxl={7}>
                        <Card className="hns-form-card mt-3">
                            <Card.Header className="hns-card-header fw-bold">{this.state.chamado_id ? `# ${this.state.numero}` : "# Novo Chamado HNS"}</Card.Header>
                            <Card.Body>
                                <Form onSubmit={this.enviaRegistro}>
                                    <Row className="g-3">
                                        {!isEdit && dados_usuario.tipo_usuario !== '' && (
                                            <Col md={12} lg={12}>
                                                <h5 className="mt-3">Olá, <strong>{dados_usuario.name}</strong>, preencha o formulário abaixo para abrir seu chamado:</h5>
                                            </Col>
                                        )}

                                        {dados_usuario['tipo_usuario'] == "" && (
                                            <>
                                                <Col md={4} lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className="fw-semibold d-flex align-items-center gap-2"> <FiUser className="text-muted" /> Solicitante <span className="text-danger">*</span></Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            defaultOptions
                                                            loadOptions={this.carregarUsuariosFuncionarios}
                                                            placeholder="Selecione o solicitante"
                                                            noOptionsMessage={() => "Nenhum solicitante encontrado"}
                                                            onChange={this.handleChangeSolicitante}
                                                            value={this.state.solicitante_id ? { value: this.state.solicitante_id, label: this.state.solicitante_nome } : null}
                                                            styles={customStyles}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={4} lg={4}>
                                                    <Form.Label className="fw-semibold"><FiFlag className="text-muted" /> Status</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="status"
                                                        value={this.state.status}        
                                                        onChange={this.handleChange}
                                                        disabled={!dados_usuario.tipo_usuario === '' || this.state.status === 'concluido' || this.state.status === 'cancelado'}
                                                    >
                                                    {Object.entries(statusChamados).map(([value, label]) => (
                                                        <option key={value} value={value}>{label}</option>
                                                    ))}
                                                    </Form.Control>
                                                </Col>

                                                <Col md={4} lg={4}>
                                                    <Form.Label className="fw-semibold"><FiAlertCircle className="text-muted" /> Prioridade</Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="prioridade"
                                                        value={this.state.prioridade}
                                                        onChange={this.handleChange}
                                                        disabled={!dados_usuario.tipo_usuario === '' || this.state.status === 'concluido' || this.state.status === 'cancelado'}
                                                    >
                                                    {Object.entries(prioridadeChamados).map(([value, label]) => (
                                                        <option key={value} value={String(value)}>{label}</option>
                                                    ))}
                                                    </Form.Control>
                                                </Col>
                                            </>
                                        )}

                                        {dados_usuario['tipo_usuario'] === "" && (
                                            <Col md={4} lg={4}>
                                                <Form.Label className="fw-semibold d-flex align-items-center gap-2"> <FiClock className="text-muted" /> SLA de Resolução <span className="text-danger">*</span></Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="bg-light hns-sla-addon">Prazo:</InputGroup.Text>
                                                        <Form.Control
                                                            name="sla_prazo_dias"
                                                            type="number"
                                                            min={0}
                                                            step={1}
                                                            value={this.state.sla_prazo_dias}
                                                            onChange={this.handleChange}
                                                            className="text-center hns-sla-input pe-0 ps-0"
                                                        />
                                                    <InputGroup.Text className="bg-light hns-sla-addon">dias úteis</InputGroup.Text>
                                                </InputGroup>
                                            </Col>
                                        )}
                                        
                                        {isEdit && (
                                            <>
                                                <Col md={4} lg={4}>
                                                    <Form.Label className="fw-semibold"><TbCalendarTime className="text-muted" /> Data e Hora de Abertura</Form.Label>
                                                    <Form.Control
                                                        name="data_abertura"
                                                        value={formataDataHoraExibicao(new Date(this.state.data_abertura))}
                                                        readOnly
                                                        disabled
                                                    />
                                                </Col>
                                                <Col md={4} lg={4}>
                                                    <Form.Label className="fw-semibold"><TbCalendarCheck className="text-muted" /> Previsão de Resolução</Form.Label>
                                                    <Form.Control
                                                        name="data_abertura"
                                                        value={previsao ? formataDataExibicao(previsao) : ''}
                                                        readOnly
                                                        disabled
                                                    />
                                                </Col>
                                            </>
                                        )}

                                        {(dados_usuario.tipo_usuario === '' || (dados_usuario.is_staff && dados_usuario.tipo_usuario === 'administrador')) ? (
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3 mt-3">
                                                <Form.Label><FiLayers className="text-muted"></FiLayers> Programa <span className="text-danger">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregaProgramasDelay} 
                                                    defaultOptions                       
                                                    onMenuOpen={() => this.carregarProgramas("")} 
                                                    name="programa_id"
                                                    placeholder="Nome do Programa"
                                                    noOptionsMessage={() => "Nenhum programa encontrado"}
                                                    onChange={e => this.handleChangeProgramas(e, 'programa_id')}
                                                    value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                                    styles={customStyles}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                        ) : (
                                            <>
                                                {isEdit && (
                                                <Col md={4} lg={4}>
                                                    <Form.Label className="fw-semibold"><FiFlag className="text-muted" /> Status</Form.Label>
                                                    <p className="mb-0"><span className={`badge badge-lg badge-agendamento badge-status-${String(this.state.status).toLowerCase()}`}>
                                                        {statusChamados[this.state.status] ?? this.state.status}
                                                    </span></p>
                                                </Col>
                                                )}
                                                <Col sm={12} xs={12}>
                                                    <Form.Group className="mb-3 mt-3">
                                                        <Form.Label><FiLayers className="text-muted"></FiLayers> Programa <span className="text-danger">*</span></Form.Label>
                                                        {isEdit ? (
                                                            <>
                                                                <p className="mb-0">{this.state.filtro_programa_nome}</p>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <p className="mb-0">{localStorage.getItem(`programa_nome_${dados_usuario["ambiente_programa_id"]}`)}</p>
                                                            </>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            
                                        )}

                                        {isSuperUser && (
                                            <Col md={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="fw-semibold">
                                                        <FiTag className="text-muted me-1" /> Tipo de Chamado
                                                    </Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        name="tipo"
                                                        value={this.state.tipo}
                                                        onChange={this.handleChange}
                                                    >
                                                        <option value="">Selecione o tipo...</option>
                                                        {Object.entries(tiposChamados).map(([value, label]) => (
                                                            <option key={value} value={value}>{label}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        )}

                                        <Col md={12}>
                                            <Form.Label className="fw-semibold">{isEdit ? 'Descrição do Chamado' : 'Descreva o Chamado'} <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={5}
                                                    name="descricao"
                                                    placeholder="Descreva Detalhadamente o Chamado."
                                                    value={this.state.descricao}
                                                    onChange={this.handleChange}
                                                    required
                                                    disabled={(isEdit && isViewer) || !dados_usuario.tipo_usuario === '' || this.state.status === 'concluido' || this.state.status === 'cancelado'}
                                                />
                                        </Col>
                                        
                                        <Col md={12}>
                                            <h6 className="fw-semibold d-block mt-2">Anexos</h6>

                                            {!(isEdit && isViewer) && (
                                                <div
                                                    className={`p-4 text-center hns-dropzone ${this.state.isDraggingOver ? 'dragover' : ''}`}
                                                    onDragOver={this.handleDragOver}
                                                    onDragEnter={this.handleDragEnter}
                                                    onDragLeave={this.handleDragLeave}
                                                    onDrop={this.handleDrop}
                                                >
                                                    <FiUploadCloud size={28} className="mb-2" />
                                                    <p className="mb-2">Arraste arquivos aqui ou clique para selecionar</p>

                                                    <Form.Control
                                                        ref={this.fileInputRef}
                                                        type="file"
                                                        multiple
                                                        onChange={this.handleFileChange}
                                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xls,.xlsx"
                                                        className="d-none"
                                                    />
                                                    <Button variant="secondary" size="sm" onClick={() => this.fileInputRef.current?.click()}>
                                                        Selecionar Arquivos
                                                    </Button>

                                                    <div className="mt-2">
                                                        <small className="text-muted">
                                                        PDF, DOC, DOCX, JPG, PNG, XLS, XLSX (máx. 10MB cada)
                                                        </small>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Staging: ainda não enviados */}
                                            {this.state.anexosSelecionados?.length > 0 && (
                                                <div className="mt-3">
                                                    <h6 className="mb-2">Prontos para enviar ({this.state.anexosSelecionados.length})</h6>
                                                    {this.state.anexosSelecionados.map((ax, idx) => {
                                                    const kind = this.iconForFile(ax.name, ax.type);
                                                    return (
                                                        <div key={idx} className="d-flex align-items-center gap-2 mb-2">
                                                        {kind === 'img' ? (
                                                            <img src={ax.previewUrl} alt={ax.name} style={{ maxWidth: 80, borderRadius: 4 }} />
                                                        ) : (
                                                            <span className="text-muted">
                                                            {kind === 'pdf' ? <FiFileText /> :
                                                            kind === 'doc' ? <FiFileText /> :
                                                            kind === 'xls' ? <FiFileText /> :
                                                            <FiFileText />}
                                                            </span>
                                                        )}
                                                        <div className="flex-grow-1">
                                                            <div className="fw-semibold">{ax.name}</div>
                                                            <small className="text-muted">{(ax.file.size/1024/1024).toFixed(2)} MB</small>
                                                        </div>
                                                        <Button variant="outline-danger" size="sm" onClick={() => this.handleRemoveAnexoLocal(idx)}>
                                                            Remover
                                                        </Button>
                                                        </div>
                                                    );
                                                    })}
                                                    {/* dica: se quiser permitir enviar sem precisar salvar o chamado,
                                                    basta chamar this.uploadAnexosSelecionados(this.state.chamado_id)
                                                    num botão separado quando isEdit=true */}
                                                </div>
                                            )}

                                            {/* Enviados (servidor) */}
                                            {isEdit && (
                                                <div className="mt-3">
                                                    <p className="mt-4 mb-2"><strong>Anexos enviados ({this.state.anexosServidor.length})</strong></p>

                                                    {this.state.anexosServidor.length === 0 ? (
                                                    <p className="text-muted mb-0">Nenhum anexo enviado.</p>
                                                    ) : (
                                                    <div className="list-group">
                                                        {this.state.anexosServidor.map((ax) => {
                                                        // API deve retornar pelo menos: id, nome, url (ajuste aos seus campos: arquivo, link, etc.)
                                                        const nome = ax.nome || ax.filename || ax.arquivo_nome || this.filenameFromUrl(ax.url || ax.link || ax.arquivo_url || ax.arquivo) || 'arquivo';
                                                        const url  = ax.url  || ax.link     || ax.arquivo_url  || ax.arquivo;
                                                        const kind = this.iconForFile(nome, ax.mimetype || ax.content_type);

                                                        return (
                                                            <div key={ax.id} className="list-group-item d-flex align-items-center gap-3">
                                                            {kind === 'img' ? (
                                                                <img src={url} alt={nome} style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 6 }} />
                                                            ) : (
                                                                <div className="text-muted fs-4 d-flex align-items-center justify-content-center" style={{ width: 56, height: 56 }}>
                                                                <FiFileText />
                                                                </div>
                                                            )}

                                                            <div className="flex-grow-1">
                                                                <div className="fw-semibold text-truncate">{nome}</div>
                                                                {ax.criado_em && <small className="text-muted">Enviado em {formataDataHoraExibicao(ax.criado_em)}</small>}
                                                            </div>

                                                            <div className="d-flex gap-2">
                                                                <Button as="a" href={url} target="_blank" rel="noreferrer" variant="light" size="sm">
                                                                    Visualizar
                                                                </Button>

                                                                {dados_usuario['tipo_usuario'] === "" && (
                                                                    <Button variant="outline-danger" size="sm" onClick={() => this.handleExcluirAnexoServidor(ax)}>
                                                                        Excluir
                                                                    </Button>
                                                                )}
                                                            </div>
                                                            </div>
                                                        );
                                                        })}
                                                    </div>
                                                    )}
                                                </div>
                                            )}
                                        </Col>

                                        <Col md={12} className="text-end">
                                            {!(isEdit && isViewer) && (
                                                <Button variant="success" type="submit" size="sm">
                                                    {isEdit ? (
                                                        <>
                                                            <FaCheck className="me-2" /> Atualizar Chamado
                                                        </>
                                                    ) : (
                                                        <>
                                                            <FaPaperPlane className="me-2" /> Abrir Chamado
                                                        </>
                                                    )}
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                        {isEdit && (
                        <Card className="hns-form-card mt-3">
                           <Card.Body>
                                <Row>
                                    <Col md={12}>
                                        <h4>Comentários do Chamado</h4>

                                        {this.state.loadingMensagens ? (
                                            <p>Carregando comentários...</p>
                                        ) : !Array.isArray(this.state.mensagensLista) || this.state.mensagensLista.length === 0 ? (
                                            <p>Sem comentários registrados.</p>
                                        ) : (
                                        <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px', borderRadius: '5px' }}>
                                            {this.state.mensagensLista.map((msg) => (
                                            <div key={msg.id} style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '5px' }}>
                                                <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{msg.dados_usuario.nome} </div>
                                                <div style={{ whiteSpace: 'pre-wrap', marginBottom: '5px' }}>{msg.mensagem}</div>

                                                {Array.isArray(this.state.anexosPorMensagem?.[msg.id]) &&
                                                    this.state.anexosPorMensagem[msg.id].length > 0 && (
                                                    <div className="mt-2">
                                                        <small className="text-muted d-block mb-1">Anexos:</small>
                                                        <div className="d-flex flex-wrap gap-2">
                                                        {this.state.anexosPorMensagem[msg.id].map((ax) => {
                                                            const url  = ax.url || ax.link || ax.arquivo_url || ax.arquivo;
                                                            const nome = ax.nome || ax.filename || this.filenameFromUrl(url) || 'arquivo';
                                                            const isImg = /\.(png|jpe?g|gif|webp)$/i.test(nome);

                                                            return (
                                                            <a
                                                                key={ax.id}
                                                                href={url}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className="text-decoration-none"
                                                                title={nome}
                                                                style={{ width: 100 }}
                                                            >
                                                                <div
                                                                className="border rounded bg-light"
                                                                style={{
                                                                    width: 100, height: 100,
                                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                }}
                                                                >
                                                                {isImg
                                                                    ? <img src={url} alt={nome} style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: 4 }} />
                                                                    : <FiFileText className="text-muted" />}
                                                                </div>
                                                                <div className="small text-truncate mt-1">{nome}</div>
                                                            </a>
                                                            );
                                                        })}
                                                        </div>
                                                    </div>
                                                )}

                                                <div style={{ fontSize: '0.8em', color: '#666' }}>{formataDataHoraExibicao(msg.criado_em)}</div>
                                            </div>
                                            ))}
                                        </div>
                                        )}
                                    </Col>
                                </Row>
                            </Card.Body>

                            <Card.Body>
                                {isEdit && statusChamados !== "Concluido" && (
                                    <Form onSubmit={this.handleEnviaMensagens}>
                                        <Row className="g-2">
                                            <hr />
                                            <h4 className="mb-2">Adicionar novo comentário</h4>

                                            {this.state.mensagensForm.map((valor, idx) => (
                                                <Col md={12} key={idx}>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={4}
                                                        value={valor}
                                                        onChange={(e) => this.handleChangeMensagem(idx, e)}
                                                    />
                                                </Col>
                                            ))}
                                            <div
                                                className={`p-3 text-center hns-dropzone ${this.state.isDraggingMsgOver ? 'dragover' : ''}`}
                                                onDragOver={this.handleMensagemDragOver}
                                                onDragEnter={this.handleMensagemDragEnter}
                                                onDragLeave={this.handleMensagemDragLeave}
                                                onDrop={this.handleMensagemDrop}
                                                >
                                                <FiUploadCloud size={22} className="mb-2" />
                                                <p className="mb-2">Arraste arquivos aqui ou clique para selecionar (comentário)</p>

                                                <Form.Control
                                                    ref={(r) => (this.fileMsgInputRef = r)}
                                                    type="file"
                                                    multiple
                                                    onChange={this.handleMensagemFileChange}
                                                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xls,.xlsx"
                                                    className="d-none"
                                                />
                                                <Button
                                                    variant="secondary"
                                                    size="sm"
                                                    onClick={() => this.fileMsgInputRef?.click()}
                                                >
                                                    Selecionar Arquivos
                                                </Button>

                                                <div className="mt-2">
                                                    <small className="text-muted">PDF, DOC, DOCX, JPG, PNG, XLS, XLSX (máx. 10MB cada; até 5 por comentário)</small>
                                                </div>
                                            </div>

                                            {/* staging dos anexos do comentário */}
                                            {this.state.mensagensAnexosSelecionados?.length > 0 && (
                                                <div className="mt-2">
                                                    <h6 className="mb-2">Anexos do comentário ({this.state.mensagensAnexosSelecionados.length})</h6>
                                                    {this.state.mensagensAnexosSelecionados.map((ax, idx) => (
                                                    <div key={idx} className="d-flex align-items-center gap-2 mb-2">
                                                        {ax.type?.startsWith('image/') ? (
                                                        <img src={ax.previewUrl} alt={ax.name} style={{ maxWidth: 72, borderRadius: 4 }} />
                                                        ) : (
                                                        <span className="text-muted"><FiFileText /></span>
                                                        )}
                                                        <div className="flex-grow-1">
                                                        <div className="fw-semibold text-truncate" style={{ maxWidth: 280 }}>{ax.name}</div>
                                                        <small className="text-muted">{(ax.file.size/1024/1024).toFixed(2)} MB</small>
                                                        </div>
                                                        <Button variant="outline-danger" size="sm" onClick={() => this.handleRemoveMensagemAnexoLocal(idx)}>
                                                        Remover
                                                        </Button>
                                                    </div>
                                                    ))}
                                                </div>
                                            )}
                                            <Col md={12} className="d-flex justify-content-end mt-4">
                                                <Button variant="success" type="submit" size="sm" >
                                                    <FaCheck className="me-2" />
                                                        Salvar Comentário
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </Card.Body>
                            
                        </Card>
                        )}
                        {/* Ações de validação (somente para viewer quando status == validacao) */}
                        {isEdit && isViewer && this.state.status === 'validacao' && (
                        <Row>
                            <Col md={12} className="d-flex gap-2 justify-content-end mt-5">
                                <Button
                                    variant="success"
                                    size="sm"
                                    disabled={this.state.processandoValidacao}
                                    onClick={this.handleAprovarConclusao}
                                >
                                    Aprovar Conclusão do Chamado
                                </Button>
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    disabled={this.state.processandoValidacao}
                                    onClick={this.handleReprovarConclusao}
                                >
                                    Reprovar Conclusão do Chamado
                                </Button>
                            </Col>
                        </Row>
                        )}
                    </Col>
                </Row>
            </div>
        )
    }
}

export default withRouter(ChamadosEdit);
